var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSygnet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 267,
    viewBox: "0 0 312 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.771 98.7231C172.771 141.249 138.297 175.723 95.7715 175.723C53.2456 175.723 18.7715 141.249 18.7715 98.7231C18.7715 56.1972 53.2456 21.7231 95.7715 21.7231C138.297 21.7231 172.771 56.1972 172.771 98.7231Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290.771 98.7231C290.771 141.249 256.074 175.723 213.271 175.723C170.469 175.723 135.771 141.249 135.771 98.7231C135.771 56.1972 170.469 21.7231 213.271 21.7231C256.074 21.7231 290.771 56.1972 290.771 98.7231Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.009 49.0562L263.005 158.052L154.41 266.647L45.4143 157.651L154.009 49.0562Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206.533 104.747L201.775 99.9893L197.017 104.747L201.775 109.505L206.533 104.747Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M211.291 109.505L206.533 104.747L201.775 109.505L206.533 114.263L211.291 109.505Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.049 114.263L211.291 109.505L206.533 114.263L211.291 119.021L216.049 114.263Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M197.017 104.747L192.259 99.9893L187.501 104.747L192.259 109.505L197.017 104.747Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M206.533 114.262L201.775 109.504L197.017 114.262L201.775 119.02L206.533 114.262Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M211.291 119.02L206.533 114.262L201.775 119.02L206.533 123.778L211.291 119.02Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M187.501 104.747L182.743 99.9893L177.985 104.747L182.743 109.505L187.501 104.747Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M130.159 50.9841L125.401 46.2261L120.643 50.9841L125.401 55.7422L130.159 50.9841Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M197.017 114.263L192.259 109.505L187.501 114.263L192.259 119.021L197.017 114.263Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M201.775 119.021L197.017 114.263L192.259 119.021L197.017 123.779L201.775 119.021Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M182.743 109.505L177.985 104.747L173.227 109.505L177.985 114.263L182.743 109.505Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M125.401 55.7414L120.643 50.9834L115.885 55.7414L120.643 60.4995L125.401 55.7414Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M187.501 114.263L182.743 109.505L177.985 114.263L182.743 119.021L187.501 114.263Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M130.159 60.4997L125.401 55.7417L120.643 60.4997L125.401 65.2578L130.159 60.4997Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M192.259 119.021L187.501 114.263L182.743 119.021L187.501 123.779L192.259 119.021Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M134.917 65.2576L130.159 60.4995L125.401 65.2576L130.159 70.0156L134.917 65.2576Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M197.017 123.779L192.259 119.021L187.501 123.779L192.259 128.537L197.017 123.779Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M177.985 114.262L173.227 109.504L168.469 114.262L173.227 119.02L177.985 114.262Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M120.643 60.4991L110.922 50.7783L106.164 55.5364L115.885 65.2572L120.643 60.4991Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M182.743 119.02L177.985 114.262L173.227 119.02L177.985 123.778L182.743 119.02Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M125.401 65.2571L120.643 60.499L115.885 65.2571L120.643 70.0151L125.401 65.2571Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M192.259 128.537L187.501 123.779L182.743 128.537L187.501 133.295L192.259 128.537Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M197.017 133.295L192.259 128.537L187.501 133.295L192.259 138.053L197.017 133.295Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M173.227 119.021L168.469 114.263L163.711 119.021L168.469 123.779L173.227 119.021Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M192.259 138.053L187.501 133.295L182.743 138.053L187.501 142.811L192.259 138.053Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M168.469 123.779L163.711 119.021L158.953 123.779L163.711 128.537L168.469 123.779Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M111.127 70.0154L106.369 65.2573L101.611 70.0154L106.369 74.7734L111.127 70.0154Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M177.985 133.295L173.227 128.537L168.469 133.295L173.227 138.053L177.985 133.295Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M187.501 142.811L182.743 138.053L177.985 142.811L182.743 147.569L187.501 142.811Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M163.711 128.537L158.953 123.779L154.195 128.537L158.953 133.295L163.711 128.537Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M106.369 74.7737L101.611 70.0156L96.8528 74.7737L101.611 79.5317L106.369 74.7737Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M168.469 133.295L163.711 128.537L158.953 133.295L163.711 138.053L168.469 133.295Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M111.127 79.5315L106.369 74.7734L101.611 79.5315L106.369 84.2895L111.127 79.5315Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M177.985 142.811L173.227 138.053L168.469 142.811L173.227 147.569L177.985 142.811Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M182.743 147.569L177.985 142.811L173.227 147.569L177.985 152.327L182.743 147.569Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M120.888 95.2307L116.13 90.4727L111.372 95.2307L116.13 99.9887L120.888 95.2307Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M130.405 104.747L125.646 99.9893L120.888 104.747L125.646 109.505L130.405 104.747Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M135.162 109.505L130.404 104.747L125.646 109.505L130.404 114.263L135.162 109.505Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M139.921 114.263L135.163 109.505L130.405 114.263L135.163 119.021L139.921 114.263Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M144.678 119.021L139.92 114.263L135.162 119.021L139.92 123.779L144.678 119.021Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M149.437 123.779L144.679 119.021L139.921 123.779L144.679 128.537L149.437 123.779Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M168.469 142.811L163.711 138.053L158.953 142.811L163.711 147.569L168.469 142.811Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4199 49.1829L81.6619 44.4248L69.0062 57.0805L73.7643 61.8385L86.4199 49.1829Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M110.941 89.0886L106.183 84.3306L101.425 89.0886L106.183 93.8467L110.941 89.0886Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9375 84.5159L90.1794 79.7578L85.4214 84.5159L90.1794 89.2739L94.9375 84.5159Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M106.369 55.5569L101.611 50.7988L96.8528 55.5569L101.611 60.3149L106.369 55.5569Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M115.514 46.4114L110.756 41.6533L105.998 46.4114L110.756 51.1694L115.514 46.4114Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M90.365 53.2703L85.6069 48.5122L80.8489 53.2703L85.6069 58.0283L90.365 53.2703Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6914 44.9441L93.9333 40.186L85.4214 48.698L90.1795 53.456L98.6914 44.9441Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M125.421 74.6091L120.663 69.8511L111.046 79.4682L115.804 84.2262L125.421 74.6091Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M177.985 152.327L173.227 147.569L168.469 152.327L173.227 157.085L177.985 152.327Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M187.501 161.843L182.743 157.084L177.985 161.843L182.743 166.601L187.501 161.843Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M192.259 166.601L187.501 161.843L182.743 166.601L187.501 171.359L192.259 166.601Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M197.017 171.359L192.259 166.601L187.501 171.359L192.259 176.117L197.017 171.359Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M201.775 176.116L197.017 171.358L192.259 176.116L197.017 180.874L201.775 176.116Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M206.533 180.875L201.775 176.117L197.017 180.875L201.775 185.633L206.533 180.875Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M116.13 99.9885L111.372 95.2305L106.614 99.9885L111.372 104.747L116.13 99.9885Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M120.888 104.747L116.13 99.9893L111.372 104.747L116.13 109.505L120.888 104.747Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M130.405 114.262L125.646 109.504L120.888 114.262L125.646 119.02L130.405 114.262Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M135.162 119.02L130.404 114.262L125.646 119.02L130.404 123.778L135.162 119.02Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M149.437 133.295L144.679 128.537L139.921 133.295L144.679 138.053L149.437 133.295Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M158.953 142.811L154.195 138.053L149.437 142.811L154.195 147.569L158.953 142.811Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M173.227 157.085L168.469 152.327L163.711 157.085L168.469 161.843L173.227 157.085Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M187.501 171.359L182.743 166.601L177.985 171.359L182.743 176.117L187.501 171.359Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M197.017 180.875L192.259 176.117L187.501 180.875L192.259 185.633L197.017 180.875Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M201.775 185.633L197.017 180.875L192.259 185.633L197.017 190.391L201.775 185.633Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M111.372 104.747L106.614 99.9893L101.856 104.747L106.614 109.505L111.372 104.747Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M116.13 109.505L111.372 104.747L106.614 109.505L111.372 114.263L116.13 109.505Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M125.646 119.021L120.888 114.263L116.13 119.021L120.888 123.779L125.646 119.021Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M135.162 128.537L130.404 123.779L125.646 128.537L130.404 133.295L135.162 128.537Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M139.92 133.295L135.162 128.537L130.404 133.295L135.162 138.053L139.92 133.295Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M144.678 138.053L139.92 133.295L135.162 138.053L139.92 142.811L144.678 138.053Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M154.195 147.569L149.437 142.811L144.678 147.569L149.437 152.327L154.195 147.569Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M163.711 157.086L158.953 152.328L154.195 157.086L158.953 161.844L163.711 157.086Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7644 71.3552L69.0063 66.5972L64.2483 71.3552L69.0063 76.1133L73.7644 71.3552Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M173.227 166.601L168.469 161.843L163.71 166.601L168.469 171.359L173.227 166.601Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M187.501 180.875L182.743 176.117L177.985 180.875L182.743 185.633L187.501 180.875Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M192.259 185.633L187.501 180.875L182.743 185.633L187.501 190.391L192.259 185.633Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M201.775 195.15L197.017 190.392L192.259 195.15L197.017 199.908L201.775 195.15Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M106.614 109.505L101.856 104.747L97.0982 109.505L101.856 114.263L106.614 109.505Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M111.372 114.263L106.614 109.505L101.856 114.263L106.614 119.021L111.372 114.263Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M116.13 119.021L111.372 114.263L106.614 119.021L111.372 123.779L116.13 119.021Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M130.405 133.295L125.646 128.537L120.888 133.295L125.646 138.053L130.405 133.295Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M149.437 152.327L144.679 147.569L139.921 152.327L144.679 157.085L149.437 152.327Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M177.985 180.875L173.227 176.117L168.469 180.875L173.227 185.633L177.985 180.875Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M182.743 185.633L177.985 180.875L173.227 185.633L177.985 190.391L182.743 185.633Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M187.501 190.391L182.743 185.633L177.985 190.391L182.743 195.149L187.501 190.391Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M192.259 195.15L187.501 190.392L182.743 195.15L187.501 199.908L192.259 195.15Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M116.13 128.537L111.372 123.779L106.614 128.537L111.372 133.295L116.13 128.537Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M130.405 142.811L125.646 138.053L120.888 142.811L125.646 147.569L130.405 142.811Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M144.679 157.085L139.921 152.327L135.163 157.085L139.921 161.843L144.679 157.085Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M154.195 166.601L149.437 161.843L144.679 166.601L149.437 171.359L154.195 166.601Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2485 80.8708L59.4905 76.1128L54.7324 80.8708L59.4905 85.6289L64.2485 80.8708Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M163.711 176.116L158.953 171.358L154.195 176.116L158.953 180.874L163.711 176.116Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7646 90.3865L69.0066 85.6284L64.2485 90.3865L69.0066 95.1445L73.7646 90.3865Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3533 60.8913L57.5952 56.1333L52.8372 60.8913L57.5952 65.6494L62.3533 60.8913Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M177.985 190.391L173.227 185.633L168.469 190.391L173.227 195.149L177.985 190.391Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M187.501 199.907L182.743 195.149L177.985 199.907L182.743 204.666L187.501 199.907Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M135.162 157.085L130.404 152.327L125.646 157.085L130.404 161.843L135.162 157.085Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M149.437 171.359L144.679 166.601L139.921 171.359L144.679 176.117L149.437 171.359Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4902 85.6287L54.7322 80.8706L49.9741 85.6287L54.7322 90.3867L59.4902 85.6287Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M154.195 176.116L149.437 171.358L144.678 176.116L149.437 180.874L154.195 176.116Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2483 90.3865L59.4902 85.6284L54.7322 90.3865L59.4902 95.1445L64.2483 90.3865Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0786 66.988L83.3206 62.23L78.5625 66.988L83.3206 71.7461L88.0786 66.988Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M158.953 180.875L154.195 176.117L149.437 180.875L154.195 185.633L158.953 180.875Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0063 95.1453L64.2483 90.3872L59.4902 95.1453L64.2483 99.9033L69.0063 95.1453Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2161 124.515L49.9741 129.273L54.7322 124.515L49.9741 119.757L45.2161 124.515Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9822 120.335L57.2241 125.093L61.9822 129.851L66.7402 125.093L61.9822 120.335Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5952 65.6496L52.8372 60.8916L48.0791 65.6496L52.8372 70.4077L57.5952 65.6496Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2893 67.2932L92.5312 62.5352L83.3207 71.7457L88.0788 76.5037L97.2893 67.2932Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M163.711 185.633L158.953 180.875L154.195 185.633L158.953 190.391L163.711 185.633Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7644 99.9031L69.0063 95.145L64.2483 99.9031L69.0063 104.661L73.7644 99.9031Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M40.458 119.758L45.2161 124.516L49.9741 119.758L45.2161 115L40.458 119.758Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M66.74 115.576L61.9819 120.334L66.74 125.092L71.498 120.334L66.74 115.576Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M62.353 70.4079L57.595 65.6499L52.8369 70.4079L57.595 75.166L62.353 70.4079Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M168.469 190.391L163.711 185.633L158.953 190.391L163.711 195.149L168.469 190.391Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M177.985 199.907L173.227 195.149L168.469 199.907L173.227 204.666L177.985 199.907Z",
    fill: "black"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M182.743 204.665L177.985 199.907L173.227 204.665L177.985 209.423L182.743 204.665Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M139.921 171.359L135.163 166.601L130.405 171.359L135.163 176.117L139.921 171.359Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9741 85.6287L45.2161 80.8706L40.458 85.6287L45.2161 90.3867L49.9741 85.6287Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0225 75.3708L48.2644 70.6128L43.5064 75.3708L48.2644 80.1289L53.0225 75.3708Z",
    fill: "black"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4016 96.7092L40.6436 91.9512L35.8855 96.7092L40.6436 101.467L45.4016 96.7092Z",
    fill: "black"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7402 133.29L61.9822 128.532L57.2241 133.29L61.9822 138.048L66.7402 133.29Z",
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M149.437 180.875L144.679 176.117L139.921 180.875L144.679 185.633L149.437 180.875Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4905 95.1453L54.7324 90.3872L49.9744 95.1453L54.7324 99.9033L59.4905 95.1453Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M158.953 190.391L154.195 185.633L149.437 190.391L154.195 195.149L158.953 190.391Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M73.567 109.221L64.2485 99.9028L59.4905 104.661L68.809 113.979L73.567 109.221Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2161 115L49.9741 119.758L54.7322 115L49.9741 110.242L45.2161 115Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4978 120.335L66.7397 125.093L71.4978 129.851L76.2558 125.093L71.4978 120.335Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5102 112.528L74.7522 117.286L79.5102 122.044L84.2683 117.286L79.5102 112.528Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M163.711 195.15L158.953 190.392L154.195 195.15L158.953 199.908L163.711 195.15Z",
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M182.743 214.181L177.985 209.423L173.227 214.181L177.985 218.939L182.743 214.181Z",
    fill: "black"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M125.646 166.601L120.888 161.843L116.13 166.601L120.888 171.359L125.646 166.601Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M139.921 180.875L135.163 176.117L130.405 180.875L135.163 185.633L139.921 180.875Z",
    fill: "black"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M144.679 185.633L139.921 180.875L135.163 185.633L139.921 190.391L144.679 185.633Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7324 99.9031L49.9744 95.145L40.8386 104.281L45.5967 109.039L54.7324 99.9031Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M149.437 190.391L144.679 185.633L139.921 190.391L144.679 195.149L149.437 190.391Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4905 104.661L54.7324 99.9028L49.9744 104.661L54.7324 109.419L59.4905 104.661Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M154.195 195.15L149.437 190.392L144.679 195.15L149.437 199.908L154.195 195.15Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M158.953 199.907L154.195 195.149L149.437 199.907L154.195 204.666L158.953 199.907Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M168.469 209.423L163.711 204.665L158.953 209.423L163.711 214.181L168.469 209.423Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M173.227 214.181L168.469 209.423L163.711 214.181L168.469 218.939L173.227 214.181Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M182.743 223.697L177.985 218.939L173.227 223.697L177.985 228.456L182.743 223.697Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M120.888 171.359L116.13 166.601L111.372 171.359L116.13 176.117L120.888 171.359Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M125.646 176.116L120.888 171.358L116.13 176.116L120.888 180.874L125.646 176.116Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M139.921 190.391L135.163 185.633L130.405 190.391L135.163 195.149L139.921 190.391Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M154.195 204.665L149.437 199.907L144.678 204.665L149.437 209.423L154.195 204.665Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M163.711 214.181L158.953 209.423L154.195 214.181L158.953 218.939L163.711 214.181Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M168.469 218.94L163.711 214.182L158.953 218.94L163.711 223.698L168.469 218.94Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M177.985 228.455L173.227 223.697L168.469 228.455L173.227 233.213L177.985 228.455Z",
    fill: "black"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M116.13 176.116L111.372 171.358L106.614 176.116L111.372 180.874L116.13 176.116Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M135.162 195.15L130.404 190.392L125.646 195.15L130.404 199.908L135.162 195.15Z",
    fill: "black"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M149.437 209.423L144.679 204.665L139.921 209.423L144.679 214.181L149.437 209.423Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M158.953 218.94L154.195 214.182L149.437 218.94L154.195 223.698L158.953 218.94Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M163.711 223.697L158.953 218.939L154.195 223.697L158.953 228.456L163.711 223.697Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M168.469 228.455L163.711 223.697L158.953 228.455L163.711 233.213L168.469 228.455Z",
    fill: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M111.372 180.875L106.614 176.117L101.856 180.875L106.614 185.633L111.372 180.875Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M116.13 185.633L111.372 180.875L106.614 185.633L111.372 190.391L116.13 185.633Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0746 89.8509L79.3193 77.0957L74.5613 81.8537L87.3165 94.609L92.0746 89.8509Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M120.888 190.391L116.13 185.633L111.372 190.391L116.13 195.149L120.888 190.391Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8328 94.6091L92.0747 89.8511L87.3167 94.6091L92.0747 99.3672L96.8328 94.6091Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M125.647 195.15L120.889 190.392L116.131 195.15L120.889 199.908L125.647 195.15Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M101.591 99.3669L96.833 94.6089L92.075 99.3669L96.833 104.125L101.591 99.3669Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M135.163 204.665L130.405 199.907L125.646 204.665L130.405 209.423L135.163 204.665Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M154.195 223.697L149.437 218.939L144.679 223.697L149.437 228.456L154.195 223.697Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M116.13 195.15L111.372 190.392L106.614 195.15L111.372 199.908L116.13 195.15Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0747 99.3669L87.3167 94.6089L82.5586 99.3669L87.3167 104.125L92.0747 99.3669Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M144.679 223.697L139.921 218.939L135.163 223.697L139.921 228.456L144.679 223.697Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M154.195 233.213L149.437 228.455L144.678 233.213L149.437 237.971L154.195 233.213Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M158.953 237.972L154.195 233.214L149.437 237.972L154.195 242.73L158.953 237.972Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M163.711 242.73L158.953 237.972L154.195 242.73L158.953 247.488L163.711 242.73Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M101.856 190.391L97.0984 185.633L92.3403 190.391L97.0984 195.149L101.856 190.391Z",
    fill: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M111.372 199.907L106.614 195.149L101.856 199.907L106.614 204.666L111.372 199.907Z",
    fill: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3166 104.125L82.5586 99.3667L77.8005 104.125L82.5586 108.883L87.3166 104.125Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M116.13 204.665L111.372 199.907L106.614 204.665L111.372 209.423L116.13 204.665Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0747 108.883L87.3167 104.125L82.5586 108.883L87.3167 113.641L92.0747 108.883Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M260.887 131.354L265.646 126.596L260.887 121.838L256.129 126.596L260.887 131.354Z",
    fill: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M256.13 126.596L260.888 121.838L256.13 117.08L251.372 121.838L256.13 126.596Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M251.372 131.354L256.13 126.596L251.372 121.838L246.614 126.596L251.372 131.354Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M246.614 136.112L251.372 131.354L246.614 126.596L241.856 131.354L246.614 136.112Z",
    fill: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M251.372 121.838L261.093 112.118L256.335 107.36L246.614 117.08L251.372 121.838Z",
    fill: "black"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M246.614 126.596L251.372 121.838L246.614 117.08L241.856 121.838L246.614 126.596Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M241.856 112.322L246.614 107.564L241.856 102.806L237.098 107.564L241.856 112.322Z",
    fill: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M237.098 107.564L241.856 102.806L237.098 98.0481L232.34 102.806L237.098 107.564Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M232.34 112.322L237.098 107.564L232.34 102.806L227.582 107.564L232.34 112.322Z",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M262.688 87.6155L267.447 82.8574L254.791 70.2018L250.033 74.9598L262.688 87.6155Z",
    fill: "black"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M222.783 112.137L227.541 107.379L222.783 102.621L218.025 107.379L222.783 112.137Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M227.355 96.133L232.114 91.375L227.355 86.617L222.597 91.375L227.355 96.133Z",
    fill: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M256.315 107.564L261.073 102.806L256.315 98.0481L251.557 102.806L256.315 107.564Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M265.46 116.709L270.218 111.951L265.46 107.193L260.702 111.951L265.46 116.709Z",
    fill: "black"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M258.601 91.5603L263.359 86.8022L258.601 82.0442L253.843 86.8022L258.601 91.5603Z",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M266.927 99.887L271.686 95.1289L263.174 86.617L258.416 91.375L266.927 99.887Z",
    fill: "black"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M237.263 126.616L242.021 121.858L237.263 117.1L232.505 121.858L237.263 126.616Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M240.516 74.9597L245.274 70.2017L240.516 65.4436L235.758 70.2017L240.516 74.9597Z",
    fill: "black"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M231.001 65.4441L235.759 60.686L231.001 55.928L226.243 60.686L231.001 65.4441Z",
    fill: "black"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M221.485 74.9602L226.243 70.2021L221.485 65.4441L216.727 70.2021L221.485 74.9602Z",
    fill: "black"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M250.98 63.5486L255.738 58.7905L250.98 54.0325L246.222 58.7905L250.98 63.5486Z",
    fill: "black"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M226.243 60.6858L231.001 55.9277L226.243 51.1697L221.485 55.9277L226.243 60.6858Z",
    fill: "black"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M221.485 65.4436L226.243 60.6855L221.485 55.9275L216.727 60.6855L221.485 65.4436Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M244.884 89.2742L249.642 84.5161L244.884 79.7581L240.126 84.5161L244.884 89.2742Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M216.726 70.2019L221.484 65.4438L216.726 60.6858L211.968 65.4438L216.726 70.2019Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M187.356 46.4114L182.598 51.1694L187.356 55.9275L192.114 51.1694L187.356 46.4114Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M191.537 63.1775L186.779 58.4194L182.021 63.1775L186.779 67.9355L191.537 63.1775Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M246.222 58.7908L250.98 54.0327L246.222 49.2747L241.464 54.0327L246.222 58.7908Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M244.578 98.4846L249.336 93.7266L240.126 84.516L235.368 89.2741L244.578 98.4846Z",
    fill: "black"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M211.969 74.9597L216.727 70.2017L211.969 65.4436L207.21 70.2017L211.969 74.9597Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M192.114 41.6536L187.356 46.4116L192.114 51.1697L196.872 46.4116L192.114 41.6536Z",
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M196.295 67.9353L191.537 63.1772L186.779 67.9353L191.537 72.6933L196.295 67.9353Z",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M200.106 79.9436L195.348 75.1855L190.59 79.9436L195.348 84.7016L200.106 79.9436Z",
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M241.464 63.5486L246.222 58.7905L241.464 54.0325L236.706 58.7905L241.464 63.5486Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M226.243 51.1697L231.001 46.4116L226.243 41.6536L221.485 46.4116L226.243 51.1697Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M236.5 54.218L241.259 49.46L236.5 44.7019L231.742 49.46L236.5 54.218Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M215.162 46.5969L219.92 41.8389L215.162 37.0808L210.404 41.8389L215.162 46.5969Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M178.582 67.9358L183.34 63.1777L178.582 58.4197L173.824 63.1777L178.582 67.9358Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M216.726 60.6858L221.484 55.9277L216.726 51.1697L211.968 55.9277L216.726 60.6858Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M202.65 74.7623L211.969 65.4438L207.211 60.6858L197.892 70.0043L202.65 74.7623Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M196.872 46.4114L192.114 51.1694L196.872 55.9275L201.63 51.1694L196.872 46.4114Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M191.537 72.6931L186.779 67.9351L182.021 72.6931L186.779 77.4512L191.537 72.6931Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M211.969 55.928L216.727 51.1699L207.591 42.0342L202.833 46.7922L211.969 55.928Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M207.211 60.6858L211.969 55.9277L207.211 51.1697L202.453 55.9277L207.211 60.6858Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M222.021 93.2699L234.776 80.5146L230.018 75.7566L217.263 88.5118L222.021 93.2699Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M217.263 98.0281L222.021 93.27L217.263 88.512L212.505 93.27L217.263 98.0281Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M212.504 102.786L217.262 98.0283L212.504 93.2703L207.746 98.0283L212.504 102.786Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M212.504 93.2698L217.262 88.5117L212.504 83.7537L207.746 88.5117L212.504 93.2698Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M207.747 88.512L212.505 83.7539L207.747 78.9959L202.989 83.7539L207.747 88.512Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M202.988 93.2698L207.746 88.5117L202.988 83.7537L198.23 88.5117L202.988 93.2698Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M125.646 214.181L120.888 209.423L116.13 214.181L120.888 218.939L125.646 214.181Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M144.679 233.213L139.921 228.455L135.163 233.213L139.921 237.971L144.679 233.213Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M154.195 242.73L149.437 237.972L144.679 242.73L149.437 247.488L154.195 242.73Z",
    fill: "black"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M187.501 85.7145L154.195 52.4082L120.888 85.7145L154.195 119.021L187.501 85.7145Z",
    fill: "black"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M177.985 85.7141L154.195 61.9238L130.404 85.7141L154.195 109.504L177.985 85.7141Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M254.113 152.327L220.807 119.021L187.501 152.327L220.807 185.634L254.113 152.327Z",
    fill: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M244.598 152.327L220.807 128.537L197.017 152.327L220.807 176.117L244.598 152.327Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M168.469 85.7146L154.195 71.4404L139.92 85.7146L154.195 99.9887L168.469 85.7146Z",
    fill: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M235.081 152.327L220.807 138.053L206.533 152.327L220.807 166.602L235.081 152.327Z",
    fill: "black"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M120.888 152.327L87.582 119.021L54.2757 152.327L87.582 185.633L120.888 152.327Z",
    fill: "black"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M111.373 152.327L87.5823 128.537L63.792 152.327L87.5823 176.117L111.373 152.327Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M101.856 152.327L87.582 138.053L73.3079 152.327L87.582 166.601L101.856 152.327Z",
    fill: "black"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9328 55.3279C28.4606 79.8001 28.4606 119.477 52.9328 143.949L48.6218 148.26C21.7687 121.407 21.7687 77.87 48.6218 51.0169C75.4748 24.1638 119.012 24.1638 145.865 51.0169L141.554 55.3279C117.082 30.8558 77.405 30.8558 52.9328 55.3279Z",
    fill: "#181818"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.661 53.9168C282.676 78.9323 282.676 119.491 257.661 144.506L261.972 148.817C289.368 121.421 289.368 77.0022 261.972 49.6058C234.576 22.2093 190.157 22.2093 162.761 49.6058L167.072 53.9168C192.087 28.9013 232.645 28.9013 257.661 53.9168Z",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSygnet);
export default __webpack_public_path__ + "static/media/sygnet.e09aefc59491d8c95f2850a1ebce9163.svg";
export { ForwardRef as ReactComponent };